var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"center"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('div',[_c('iframe',{attrs:{"src":_vm.url,"frameborder":"0","width":"98%","height":"1000","allowtransparency":""}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }